import { v as virtualPagesTypes, e as events, a as addCartLocation, b as addCartCTAType, c as productLists, V as VIEW_ONLINE, d as virtualPagesNames, f as virtualPagesNestedLocations, E as EXTERNAL_PARTNER_NAME, r as refinementStateChangedActionNames, g as rangeTabs, G as GLOBAL_PAGE_LOAD_UPDATE_EVENT_NAME, O as ONLINE_VIEW, h as GLOBAL_ANALYTICS_EVENT_NAME } from './analytics-b3108572.js';
import { y as ONLINE_SOFTWARE, z as PDP_SOFTWARE, F as ECustomerType } from './currency-49e0d692.js';
import { c as convertProductsPriceToFloat } from './number-fcf5283d.js';
import { ab as getLookupValueProductLists, a9 as getLookupValueAddCartLocation, aa as getLookupValueAddCartCTAType, ac as getLookupValueVirtualPageType, ad as getLookupValueVirtualPageName, ae as getLookupValuePageTabs } from './index-39f51a91.js';
import { O as OFFSET_PARAM_NAME, P as PRODUCTS_PER_PAGE_PARAM_NAME } from './navigation-83d2f79a.js';

const getAddToCartLocation = (params, location, ctaType) => {
    const { relatedSectionId = '' } = params;
    const locationValue = getLookupValueProductLists(location, relatedSectionId)
        || getLookupValueAddCartLocation(location, relatedSectionId);
    const ctaTypeValue = getLookupValueAddCartCTAType(ctaType);
    return `${locationValue}|${ctaTypeValue}`;
};
const getPageSubSubCategory = (params, virtualPageType, virtualPageName) => {
    const { relatedSectionId = '', mainDocumentType = '', circularType = '' } = params || {};
    const virtualPageTypeValue = getLookupValueVirtualPageType(virtualPageType);
    const virtualPageNameValue = getLookupValueVirtualPageName(virtualPageName || '', relatedSectionId || mainDocumentType || circularType);
    return virtualPageType === virtualPagesTypes.MODAL_WINDOW
        ? `${virtualPageTypeValue}|${virtualPageNameValue}`
        : virtualPageTypeValue;
};
const setActualNoParam = (url, pageNoParam) => {
    const noParamRegExp = /No=\d+/;
    const noParamReplacement = `No=${pageNoParam}`;
    if (url.includes('No=')) {
        return url.replace(noParamRegExp, noParamReplacement);
    }
    return `${url}${url.includes('?') ? '&' : '?'}${noParamReplacement}`;
};
/**
 * Builds a URL pathname from an array of path segments
 * by concatenating the elements with slashes.
 * The function is not going to replace empty strings.
 */
const buildUrlPathnameFromArray = (pathParametersArray) => {
    const pathReducer = (accumulatedPath, currentPathSegment) => {
        return `${accumulatedPath}/${currentPathSegment}`;
    };
    return pathParametersArray.reduce(pathReducer, '');
};
const capitalizeFirstLetter = (input) => {
    return input.charAt(0).toUpperCase() + input.slice(1);
};

var __rest$1 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const productSelectorAddToCartEvent = (params) => {
    const { products } = params;
    const ctaType = products.length > 1
        ? addCartCTAType.BUTTON_GROUP_OF_PRODUCTS
        : addCartCTAType.BUTTON_SINGLE_PRODUCT;
    return Object.assign({ event: events.ADD_TO_CART, addToCartLocation: getAddToCartLocation(params, addCartLocation.PRODUCT_SELECTOR, ctaType) }, params);
};
const addToCartRelatedProductsEvent = (params) => {
    return Object.assign({ event: events.ADD_TO_CART, addToCartLocation: getAddToCartLocation(params, productLists.RELATED_PRODUCTS_MODAL, addCartCTAType.BUTTON_SINGLE_PRODUCT) }, params);
};
const addToCartMainEvent = (params) => {
    const { isSticky } = params, rest = __rest$1(params, ["isSticky"]);
    const location = isSticky ? addCartLocation.STICKY_BAR : addCartLocation.PRODUCT_MAIN;
    return Object.assign({ event: events.ADD_TO_CART, addToCartLocation: getAddToCartLocation(params, location, addCartCTAType.BUTTON_SINGLE_PRODUCT) }, rest);
};
const addToCartProductCardEvent = (params) => {
    const { isGridView } = params, rest = __rest$1(params, ["isGridView"]);
    const location = isGridView ? productLists.GRID_VIEW_PRODUCTS : productLists.LIST_VIEW_PRODUCTS;
    return Object.assign({ event: events.ADD_TO_CART, addToCartLocation: getAddToCartLocation(params, location, addCartCTAType.BUTTON_SINGLE_PRODUCT) }, rest);
};
const addToCartSubstitution = (params) => {
    const { products } = params;
    const ctaType = products.length > 1
        ? addCartCTAType.BUTTON_GROUP_OF_PRODUCTS
        : addCartCTAType.BUTTON_SINGLE_PRODUCT;
    return Object.assign({ event: events.ADD_TO_CART, addToCartLocation: getAddToCartLocation(params, productLists.SUBSTITUTE_PRODUCTS, ctaType) }, params);
};
const addToCartAlternative = (params) => {
    return Object.assign({ event: events.ADD_TO_CART, addToCartLocation: getAddToCartLocation(params, productLists.ALTERNATIVE_PRODUTS, addCartCTAType.BUTTON_SINGLE_PRODUCT) }, params);
};
const downloadDocumentEvent = (params) => {
    return Object.assign({ event: events.DOWNLOAD_DOCUMENT }, params);
};
const documentDownloadEvent = (params) => {
    const { isViewOnline, documentName } = params, rest = __rest$1(params, ["isViewOnline", "documentName"]);
    return Object.assign({ event: events.DOWNLOAD, documentName: isViewOnline ? VIEW_ONLINE : documentName }, rest);
};
const removeFromFavoritesEvent = (params) => {
    return Object.assign({ event: events.REMOVE_FROM_CART }, params);
};
const comparatorPageLoadEvent = (params) => {
    return Object.assign({ event: events.COMPARATOR }, params);
};
const productVariantsClickEvent = (params) => {
    const { currency } = params, product = __rest$1(params, ["currency"]);
    const listValue = getLookupValueProductLists(productLists.VARIANTS);
    return {
        event: events.PRODUCT_VIEW,
        currencyCode: currency,
        list: listValue,
        products: [product],
    };
};
const buyOnlineClickEvent = (params) => {
    return Object.assign({ event: events.VIRTUAL_PAGE_VIEW, fromWebView: false, pageSubSubCategory: getPageSubSubCategory(params, virtualPagesTypes.MODAL_WINDOW, virtualPagesNames.BUY_ONLINE) }, params);
};
const documentsDownloadClickEvent = (params) => {
    return Object.assign({ event: events.VIRTUAL_PAGE_VIEW, fromWebView: false, pageSubSubCategory: getPageSubSubCategory(params, virtualPagesTypes.MODAL_WINDOW, virtualPagesNames.DOWNLOAD) }, params);
};
const paginationClickEvent = (params) => {
    const { pageNoParam, articleTitle } = params;
    let page = '';
    if (pageNoParam) {
        const currentUrl = window.decodeURI(window.location.href);
        page = setActualNoParam(currentUrl, pageNoParam);
    }
    return {
        event: events.VIRTUAL_PAGE_VIEW,
        fromWebView: false,
        pageSubSubCategory: getPageSubSubCategory(params, virtualPagesTypes.PAGINATION),
        page,
        articleTitle,
    };
};
const onlineSoftwareModalClickEvent = (type) => {
    const virtualPageName = type === ONLINE_SOFTWARE || type === PDP_SOFTWARE
        ? virtualPagesNames.SEE_SOFTWARE
        : virtualPagesNames.SEE_CONFIGURATOR;
    return {
        event: events.VIRTUAL_PAGE_VIEW,
        fromWebView: false,
        pageSubSubCategory: getPageSubSubCategory(null, virtualPagesTypes.MODAL_WINDOW, virtualPageName),
    };
};
const mediaGalleryPopupEvent = () => {
    return {
        event: events.VIRTUAL_PAGE_VIEW,
        fromWebView: false,
        pageSubSubCategory: getPageSubSubCategory(null, virtualPagesTypes.MODAL_WINDOW, virtualPagesNames.MEDIA_GALLERY),
    };
};
const hmcEvent = (params) => {
    const { pageCategoryId } = params;
    return Object.assign({ event: events.VIRTUAL_PAGE_VIEW, fromWebView: false, pageSubSubCategory: getPageSubSubCategory(params, virtualPagesTypes.MODAL_WINDOW, virtualPagesNames.HELP_ME_CHOOSE) }, (pageCategoryId && { pageCategoryId }));
};
const productSelectorVirtualPageEvent = (params) => {
    const { location, pageRangeId } = params || {};
    const rest = pageRangeId ? { pageRangeId } : {};
    let articleTitle = '';
    if (location === virtualPagesNestedLocations.HELP_ME_CHOOSE) {
        articleTitle = getLookupValueVirtualPageName(location);
    }
    return Object.assign({ event: events.VIRTUAL_PAGE_VIEW, fromWebView: false, pageSubSubCategory: getPageSubSubCategory(params, virtualPagesTypes.MODAL_WINDOW, virtualPagesNames.PRODUCT_SELECTOR), articleTitle }, rest);
};
const virtualPageRelatedProductsEvent = (params) => {
    return {
        event: events.VIRTUAL_PAGE_VIEW,
        fromWebView: false,
        pageSubSubCategory: getPageSubSubCategory(params, virtualPagesTypes.MODAL_WINDOW, virtualPagesNames.RELATED_PRODUCTS),
    };
};
const buyOnlineVirtualPageEvent = () => {
    return {
        event: events.VIRTUAL_PAGE_VIEW,
        fromWebView: false,
        pageSubSubCategory: getPageSubSubCategory(null, virtualPagesTypes.MODAL_WINDOW, virtualPagesNames.BUY_ONLINE),
    };
};
const buyOnlineCircularVirtualPageEvent = (params) => {
    return {
        event: events.VIRTUAL_PAGE_VIEW,
        fromWebView: false,
        pageSubSubCategory: getPageSubSubCategory(params, virtualPagesTypes.MODAL_WINDOW, virtualPagesNames.BUY_ONLINE_CIRCULAR),
    };
};
const filtersVirtualPageEvent = () => {
    return {
        event: events.VIRTUAL_PAGE_VIEW,
        fromWebView: false,
        pageSubSubCategory: getPageSubSubCategory(null, virtualPagesTypes.MODAL_WINDOW, virtualPagesNames.FILTERS),
    };
};
const mainDocumentsDropDownEvent = (params) => {
    return {
        event: events.VIRTUAL_PAGE_VIEW,
        fromWebView: false,
        pageSubSubCategory: getPageSubSubCategory(params, virtualPagesTypes.MODAL_WINDOW, virtualPagesNames.MAIN_DOCUMENTS),
    };
};
const rangeTabClickEvent = (params) => {
    const { tabHash } = params;
    const tabsArticleTitle = rangeTabs[tabHash];
    const articleTitle = getLookupValuePageTabs(tabsArticleTitle);
    return {
        event: events.VIRTUAL_PAGE_VIEW,
        fromWebView: false,
        pageSubSubCategory: getPageSubSubCategory(params, virtualPagesTypes.TABS_ON_RANGE),
        articleTitle,
    };
};
const videoStartEvent = (params) => {
    return Object.assign({ event: events.VIDEO_START }, params);
};
const videoCompleteEvent = (params) => {
    return Object.assign({ event: events.VIDEO_COMPLETE }, params);
};
const clickExternalPartnerLinkEvent = ({ 
// eslint-disable-next-line @typescript-eslint/naming-convention
external_partner_url, 
// eslint-disable-next-line @typescript-eslint/naming-convention
external_partner_name = EXTERNAL_PARTNER_NAME, }) => {
    return {
        event: events.CLICK_EXTERNAL_PARTNER_LINK,
        external_partner_name,
        external_partner_url,
    };
};
const exitToSchneiderEvent = ({ 
// eslint-disable-next-line @typescript-eslint/naming-convention
link_url, }) => {
    return {
        event: events.EXIT_TO_SCHNEIDER,
        link_url,
    };
};
const viewExternalPartnerLink = ({ 
// eslint-disable-next-line @typescript-eslint/naming-convention
external_partner_url, 
// eslint-disable-next-line @typescript-eslint/naming-convention
external_partner_name, }) => {
    return {
        event: events.VIEW_EXTERNAL_PARTNER_LINK,
        external_partner_name,
        external_partner_url,
    };
};
const viewItemEvent = (params) => {
    return Object.assign({ event: events.VIEW_ITEM }, params);
};
const csExitToSchneiderEvent = ({ 
// eslint-disable-next-line @typescript-eslint/naming-convention
link_url, }) => {
    return {
        event: events.CS_EXIT_TO_SCHNEIDER,
        link_url,
    };
};
const selectItemCTAEvent = (params) => {
    return Object.assign({ event: events.SELECT_ITEM_CTA }, params);
};
const viewItemListEvent = (params) => {
    return Object.assign({ event: events.VIEW_ITEM_LIST }, params);
};
const rangeCtaClickEvent = (params) => {
    return Object.assign({ event: events.CTA_CLICK }, params);
};
const refinementStateChangedEvent = (params) => {
    const { isChecked } = params, rest = __rest$1(params, ["isChecked"]);
    return Object.assign({ event: events.FILTER_CLICK, filterAction: isChecked
            ? refinementStateChangedActionNames.FILTER_SELECTED
            : refinementStateChangedActionNames.FILTER_DESELECTED }, rest);
};
function buildPageViewPayload(params) {
    var _a;
    let { articleTitle } = params;
    if (params.pageTabs
        && params.pesPageTypes
        && params.pageRangeId
        && params.pageTopCategory === params.pesPageTypes.productRangePage
        && params.tabKey) {
        articleTitle = params.pageTabs[params.tabKey];
    }
    return {
        event: events.PAGE_VIEW,
        articleTitle: articleTitle || articleTitle === 0 ? articleTitle : null,
        pageTitle: params.pageTitle || null,
        fromWebView: (_a = params.fromWebView) !== null && _a !== void 0 ? _a : null,
        pageLanguage: params.pageLanguage || null,
        businessUnit: params.businessUnit || null,
        template: params.template || null,
        pageTopCategory: params.pageTopCategory || null,
        pageCategory: params.pageCategory || null,
        pageSubCategory: params.pageSubCategory || null,
        pageSubSubCategory: params.pageSubSubCategory || null,
        pageCategoryId: params.pageCategoryId || null,
        pageSubCategoryId: params.pageSubCategoryId || null,
        pageRangeId: params.pageRangeId || null,
        pageProductId: params.pageProductId || null,
    };
}

const updatePageLoadData = (params) => {
    const event = new CustomEvent(GLOBAL_PAGE_LOAD_UPDATE_EVENT_NAME, {
        detail: params,
        bubbles: true,
        composed: true,
    });
    window.dispatchEvent(event);
};
/**
 * Sets Query param if exists or removes from params if the value wasn't provided
 */
const setQueryParam = (searchParams, paramName, value) => {
    if (value) {
        searchParams.set(paramName, value);
    }
    else {
        searchParams.delete(paramName);
    }
};
function setPaginationParams(offset, nrpp, pushToHistory = false) {
    const searchParams = new URLSearchParams(window.location.search);
    setQueryParam(searchParams, OFFSET_PARAM_NAME, offset.toString());
    setQueryParam(searchParams, PRODUCTS_PER_PAGE_PARAM_NAME, nrpp.toString());
    if (pushToHistory) {
        window.history.pushState(null, '', `?${searchParams.toString()}${window.location.hash}`);
    }
    return searchParams;
}
const setArticleTitle = (articleTitle) => {
    updatePageLoadData({ articleTitle: getLookupValuePageTabs(articleTitle) });
};
const isAnalyticsEnabled = () => !window.analyticsDisabled;
/**
 * Returns cookie value or undefined if no cookie.
 */
const getCookie = (name) => {
    const regexp = new RegExp(`(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`);
    const matches = document.cookie.match(regexp);
    return matches ? decodeURIComponent(matches[1]) : undefined;
};
const getUserSessionLoggedInValue = () => {
    return getCookie(ECustomerType.CLASSIFICATION1);
};

var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const addToCart = (param) => {
    const { products } = param, rest = __rest(param, ["products"]);
    const newProducts = convertProductsPriceToFloat(products);
    return Object.assign({ products: newProducts }, rest);
};
const removeFromCart = (param) => {
    const { products } = param, rest = __rest(param, ["products"]);
    const newProducts = convertProductsPriceToFloat(products);
    return Object.assign({ products: newProducts }, rest);
};
const download = (param) => {
    const { documentReference, documentId, documentName } = param, rest = __rest(param, ["documentReference", "documentId", "documentName"]);
    return Object.assign(Object.assign({}, rest), { documentId: documentId || documentReference, documentName: documentName === ONLINE_VIEW || documentName === VIEW_ONLINE ? VIEW_ONLINE : documentName, event: events.DOWNLOAD });
};
const virtualPageview = (data) => {
    const { page } = data;
    if (page) {
        return data;
    }
    const currentUrl = window.decodeURI(window.location.href);
    return Object.assign(Object.assign({}, data), { page: currentUrl });
};
const postProcessing = (data) => {
    switch (data.event) {
        case events.VIRTUAL_PAGE_VIEW:
            return virtualPageview(data);
        case events.ADD_TO_CART:
            return addToCart(data);
        case events.DOWNLOAD:
        case events.DOWNLOAD_DOCUMENT:
            return download(data);
        case events.REMOVE_FROM_CART:
            return removeFromCart(data);
        default:
            return data;
    }
};
const send = (eventDetailsBuilder, params) => {
    const event = new CustomEvent(GLOBAL_ANALYTICS_EVENT_NAME, {
        detail: postProcessing(eventDetailsBuilder(params)),
        bubbles: true,
        composed: true,
    });
    window.dispatchEvent(event);
};
/**
 * Returns value of a param from the url
 * @paramName can be a list of params divided through | . In this case, returns the first match.
 * E.g. p_File_Name or p_File_Name|p_enDocType
 */
const getParamValueFromURL = (url, paramName) => {
    var _a;
    const regExp = new RegExp(`[?&](${paramName})=([^&]+).*$`);
    return (_a = url.match(regExp)) === null || _a === void 0 ? void 0 : _a[2];
};
const externalLinkHandler = (link) => {
    var _a, _b;
    const documentId = getParamValueFromURL(link, 'p_Doc_Ref');
    if (!documentId) {
        return;
    }
    const documentName = (_a = getParamValueFromURL(link, 'p_File_Name|p_Archive_Name|p_FileName')) !== null && _a !== void 0 ? _a : '';
    const documentType = (_b = getParamValueFromURL(link, 'p_enDocType')) !== null && _b !== void 0 ? _b : '';
    send(documentDownloadEvent, { documentId, documentName, documentType });
};
const processGlobalAnalyticsEvent = (originalEvent, extraParams) => {
    originalEvent.stopPropagation();
    const { event } = originalEvent.detail;
    switch (event) {
        case 'refinementStateChanged': {
            const { isChecked } = originalEvent.detail;
            send(refinementStateChangedEvent, Object.assign({ isChecked }, extraParams));
            break;
        }
    }
};
const triggerCtaClickEvent = (ctaClickGAParams) => {
    if (isAnalyticsEnabled()) {
        send(rangeCtaClickEvent, ctaClickGAParams);
    }
};

export { getUserSessionLoggedInValue as $, buyOnlineCircularVirtualPageEvent as A, filtersVirtualPageEvent as B, mainDocumentsDropDownEvent as C, rangeTabClickEvent as D, videoStartEvent as E, videoCompleteEvent as F, clickExternalPartnerLinkEvent as G, exitToSchneiderEvent as H, viewExternalPartnerLink as I, viewItemEvent as J, csExitToSchneiderEvent as K, selectItemCTAEvent as L, viewItemListEvent as M, rangeCtaClickEvent as N, refinementStateChangedEvent as O, buildPageViewPayload as P, getAddToCartLocation as Q, getPageSubSubCategory as R, setActualNoParam as S, buildUrlPathnameFromArray as T, capitalizeFirstLetter as U, updatePageLoadData as V, setQueryParam as W, setPaginationParams as X, setArticleTitle as Y, isAnalyticsEnabled as Z, getCookie as _, processGlobalAnalyticsEvent as a, productSelectorAddToCartEvent as b, addToCartRelatedProductsEvent as c, addToCartMainEvent as d, externalLinkHandler as e, addToCartProductCardEvent as f, getParamValueFromURL as g, addToCartSubstitution as h, addToCartAlternative as i, downloadDocumentEvent as j, documentDownloadEvent as k, comparatorPageLoadEvent as l, productVariantsClickEvent as m, buyOnlineClickEvent as n, documentsDownloadClickEvent as o, postProcessing as p, paginationClickEvent as q, removeFromFavoritesEvent as r, send as s, triggerCtaClickEvent as t, onlineSoftwareModalClickEvent as u, mediaGalleryPopupEvent as v, hmcEvent as w, productSelectorVirtualPageEvent as x, virtualPageRelatedProductsEvent as y, buyOnlineVirtualPageEvent as z };
